import React from "react";

const FooterFinancialYearControl = ({
  isFiscalYearLoading,
  fiscalYears,
  selectedFiscalYear,
  formatFiscalYearShort,
  onFiscalYearChange,
}) => {
  return (
    <div className="dropdown">
      <button
        className="btn btn-link nav-link p-0 d-flex align-items-center gap-1 text-muted"
        type="button"
        data-bs-toggle="dropdown"
        aria-expanded="false"
        disabled={isFiscalYearLoading || fiscalYears.length === 0}
        title="Financial Year"
        style={{ textDecoration: "none" }}
      >
        <span style={{ fontSize: "0.8rem", lineHeight: 1 }}>FY</span>
        <span style={{ fontSize: "0.9rem", lineHeight: 1 }}>
          {formatFiscalYearShort(selectedFiscalYear || "")}
        </span>
      </button>
      <ul className="dropdown-menu dropdown-menu-end">
        {isFiscalYearLoading ? (
          <li>
            <span className="dropdown-item-text">Loading FY...</span>
          </li>
        ) : fiscalYears.length > 0 ? (
          fiscalYears.map((year) => (
            <li key={year}>
              <button
                type="button"
                className={`dropdown-item ${selectedFiscalYear === year ? "active text-white" : ""}`}
                onClick={() => onFiscalYearChange(year)}
              >
                {year}
              </button>
            </li>
          ))
        ) : (
          <li>
            <span className="dropdown-item-text">No FY</span>
          </li>
        )}
      </ul>
    </div>
  );
};

export default FooterFinancialYearControl;
